const roleOptions = {
    EMPLOYEE: 'EMPLOYEE',
    HR: 'HR',
    ADMIN: 'ADMIN'
}

const ROLES = [
    {label: "Employé", value: roleOptions.EMPLOYEE},
    {label: "Ressources Humaines", value: roleOptions.HR},
    {label: "Administrateur", value: roleOptions.ADMIN},
    // {label: "Communication", value: "COMM"},
]

Object.freeze(ROLES);
Object.freeze(roleOptions);

export { ROLES, roleOptions };